/**
 * The name to register a booking under.
 *
 * `POST /v1/customers/booking` is create-or-find and NEVER updates names
 * (openings-client apps/api/src/modules/customers/routes.ts), so whatever is
 * sent on the first write is the customer's name forever. A first-time caller
 * has no customer record yet — `client` is null — and their real name only
 * exists in the identity step's state, so that must win.
 */
export interface BookingNameSource {
  firstName?: string;
  lastName?: string;
  client?: { firstName?: string; lastName?: string } | null;
}

const clean = (value: string | undefined) => value?.trim() || "";

export const resolveBookingCustomerName = (
  state: BookingNameSource,
): { firstName: string; lastName: string } => {
  const collectedFirst = clean(state.firstName);
  const collectedLast = clean(state.lastName);
  if (collectedFirst && collectedLast) {
    return { firstName: collectedFirst, lastName: collectedLast };
  }
  return {
    firstName: clean(state.client?.firstName) || "Unknown",
    lastName: clean(state.client?.lastName) || "Unknown",
  };
};
